exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2BqJ {\n  background-color: #F8F8F8;\n  display: -ms-flexbox;\n  display: flex;\n  height: 22px;\n  -ms-flex-align: center;\n      align-items: center;\n  margin: 0px 2px 2px 0px;\n  -ms-flex-pack: center;\n      justify-content: center;\n  padding: 0 8px; }\n  ._2BqJ p {\n    color: #485460;\n    font-size: 11px;\n    font-weight: bold; }\n", ""]);

// exports
exports.locals = {
	"container": "_2BqJ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"namedExport":true,"localIdentName":"[hash:base64:4]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"data":"@import /"variables/";","includePaths":["/app/src/styles"]}!./src/pages/CompanyIndex/Companies/Company/Category/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"namedExport":true,"localIdentName":"[hash:base64:4]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"data":"@import \"variables\";","includePaths":["/app/src/styles"]}!./src/pages/CompanyIndex/Companies/Company/Category/styles.scss
// module chunks = 0